import { motion, useReducedMotion } from "framer-motion";
import { Link } from "react-router-dom";
import { StatusPill } from "../common/StatusPill";
import { Skeleton } from "../ui/skeleton";
import { COCKPIT } from "../../constants/testIds";
import { formatCurrency, relativeTimeFromNow } from "../../lib/format";
import { fadeUp } from "../../lib/motion";

// UX-01 §1 "Recent members / attention table" (EL-017). "Plan / expires" columns aren't
// fetchable without already knowing a membership ID (no list-memberships-by-member endpoint
// exists, and this prompt forbids adding one) — adapted to "Dues" from the real, existing
// GET /members/{id}/balance, with the same dot+pill status system (dues>0 = Overdue).
export function RecentMembersTable({ rows, loading }) {
  const reducedMotion = useReducedMotion();
  return (
    <div className="solid-surface rounded-[14px] overflow-hidden">
      <table className="w-full text-sm" data-testid={COCKPIT.membersTable}>
        <thead>
          <tr className="text-left" style={{ borderBottom: "1px solid var(--scarlet-hairline)" }}>
            <th className="eyebrow px-5 py-3">Member</th>
            <th className="eyebrow px-5 py-3">Phone</th>
            <th className="eyebrow px-5 py-3">Last visit</th>
            <th className="eyebrow px-5 py-3">Dues</th>
            <th className="eyebrow px-5 py-3">Status</th>
          </tr>
        </thead>
        <tbody>
          {loading && Array.from({ length: 5 }).map((_, i) => (
            <tr key={i} style={{ borderBottom: "1px solid var(--scarlet-hairline)" }}>
              <td className="px-5 py-3.5" colSpan={5}><Skeleton className="h-4 w-full shimmer" /></td>
            </tr>
          ))}
          {!loading && rows.map((m, i) => (
            <motion.tr
              key={m.id}
              {...fadeUp(reducedMotion, Math.min(i, 6) * 0.04, 6)}
              data-testid={COCKPIT.memberRow(m.id)}
              style={{ borderBottom: "1px solid var(--scarlet-hairline)" }}
            >
              <td className="px-5 py-3.5 font-medium">
                <Link to={`/app/members?highlight=${m.id}`} className="hover:underline scarlet-focusable" style={{ color: "var(--scarlet-text)" }}>{m.profile.name}</Link>
              </td>
              <td className="px-5 py-3.5 tabular-nums-force" style={{ color: "var(--scarlet-text-secondary)" }}>{m.profile.phone}</td>
              <td className="px-5 py-3.5" style={{ color: "var(--scarlet-text-secondary)" }}>{relativeTimeFromNow(m.last_visit_at)}</td>
              <td className="px-5 py-3.5 tabular-nums-force font-medium" style={{ color: "var(--scarlet-text)" }}>{formatCurrency(m.dues ?? 0)}</td>
              <td className="px-5 py-3.5"><StatusPill status={m.dues > 0 ? "overdue" : "active"} /></td>
            </motion.tr>
          ))}
          {!loading && rows.length === 0 && (
            <tr><td colSpan={5} className="px-5 py-8 text-center text-sm" style={{ color: "var(--scarlet-text-secondary)" }}>No members yet.</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
